// import { useMsal } from "@azure/msal-react";
// import { Navigate } from "react-router-dom";
 
// const ProtectedRoute = ({ children }) => {
//   const { accounts } = useMsal();
 
//   // Google login stored after success
//   const googleUser = localStorage.getItem("google_user");
 
//   const isCustomLoggedIn = sessionStorage.getItem("isLoggedIn") === "true";
 
//   const isMsLoggedIn = accounts && accounts.length > 0;
//   const isGoogleLoggedIn = !!googleUser;
 
//   // If neither MS nor Google is logged in → redirect
//   if (!isMsLoggedIn && !isGoogleLoggedIn && !isCustomLoggedIn) {
//     return <Navigate to="/" replace />;
//   }
 
//   return children;
// };
 
// export default ProtectedRoute;
 
import { Navigate } from "react-router-dom";
import { isTokenValid } from "../../store/auth";
 
const ProtectedRoute = ({ children }) => {
  // If token is missing or expired, redirect to login
  if (!isTokenValid()) {
  return <Navigate to="/" replace />;
}
return children;
};

export default ProtectedRoute;
//new code

